import React from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import { Spinner } from 'react-activity';
import { UserAccess, CampaignAccess, FileAccess, SounditiAuth, AnalysisAccess } from '@sounditi/ft2-api';
import { Helmet } from 'react-helmet'
import { withTranslation } from 'react-i18next';
import T from '../../components/Translate';
import Link from '../../components/Link';
import ModalDialogInfo from '../../components/ModalDialogInfo';
import ModalDialog from '../../components/ModalDialog';
import Input from '../../components/Input';
import TopBar from '../../components/TopBar';
import ContentHeader from '../../components/ContentHeader';
import MobileTopBar from '../../components/MobileTopBar';
import MetricsModule from '../../components/metrics/MetricsModule';

import EmotionalOverviewFilm from '../../components/metrics/EmotionalOverviewFilm';
import AverageEmotionsFilms from '../../components/metrics/AverageEmotionsFilms';

import { setSession } from '../../reducers/user';
import { showNotification } from '../../reducers/notifications';
import { setRedirect, setDisableToggleDemo } from '../../reducers/navigation';
import { setTestsData } from '../../reducers/user';
import { getURLParameter, getVideoAspect, getImageAspect } from '../../utils/global';
import { getMetadata, getThumbnails } from 'video-metadata-thumbnails';
import { parseNivoRepliesQA, parseNivoReplies } from '../../utils/metrics';

import { URL_WIZARD, URL_CAMPAIGNS, URL_CAMPAIGN_MODULES_ID } from '../../config/urls';
import { URL_ENVIRONMENT } from '../../config/global';
import { result } from 'lodash';

const uuidv4 = require("uuid/v4");

const mapStateToProps = (state, ownProps) => ({
  auth: state.auth.api,
  campaignsData: state.user.testsData,
  userData: state.user.userData,
  testsData: state.user.testsData,
  loadingMetrics: state.navigation.loadingMetrics,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  setTestsData: val => dispatch(setTestsData(val)),
  setSession: val => dispatch(setSession(val)),
  showNotification: val => dispatch(showNotification(val)),
  setRedirect: val => dispatch(setRedirect(val)),
  setDisableToggleDemo: val => dispatch(setDisableToggleDemo(val)),
  dispatch,
})

class Metrics extends React.Component {
  _mount = true;

  constructor(props) {
    super(props);
    this.state = {
      loadingCampaign: true,
      loading: true,
      refreshingData: false,
      userPassword: "",
      campaignName: "",
      campaignData: [],
      campaignModules: [],
      link: "",
      allModulesMetrics: [],
      showTestOptions: false,
      showSendLinkPanel: false,
      showEmailModal: false,
      showEditTestModal: false,
      showDemoData: false,
      modalLoading: false,
      showDesktopPromo: false,
      haveDemo: true,
      previewTime: 0,
      previewDuration: 0,
      timelinePositionMouseX: 0,
      timelinePositionData: []
    };
  }

  componentWillMount() {
    this.loadData();
  }

  componentDidMount() {
    const campaignId = getURLParameter("id") || undefined;
    const {testsData} = this.props;

    if (testsData) {
      let campaignData = testsData[testsData.length - 1];

      if (testsData.filter(test => test.campaignId === campaignId).length > 0) {
        campaignData = testsData.filter(test => test.campaignId === campaignId)[0];
        const campaignDataModules = campaignData.data.modules.campaignModules;
        if (campaignDataModules && campaignDataModules.length < 1) {
          this.setState({ haveDemo: false });
        } else if (campaignData.globalSummary.tests_started < 1) {
          this.setState({ showDemoData: true });
        }
      }
    }

    document.getElementById('body').className='metrics';

    window.addEventListener('click', (e) => {
      let closePopup = true;

      Array.from(document.getElementsByClassName('btn-send-test')).forEach(element => {
        if (element.contains(e.target)){
          closePopup = false;
        }
      });

      if (this._mount && closePopup)
        this.setState({ showTestOptions: false });
    });

    document.addEventListener('keypress', event => {
      if (event.code === 'Space' && this._mount) {
        this.onClickPlay();

        event.stopPropagation();
        event.preventDefault();
      }
    });
  }

  componentDidUpdate() {
    const { loading } = this.state;
    const { setDisableToggleDemo } = this.props;
    setDisableToggleDemo(loading);
  }

  componentWillUnmount(){
    // document.getElementById('body').className=''
  }

  toggleTestOptions() {
    const { showTestOptions } = this.state;
    this.setState({ showTestOptions: !showTestOptions });
  }

  loggout() {
    localStorage.clear();
    const auth = new SounditiAuth();
    auth.logOut();
    window.Froged('logout');
    window.location.reload();
  }

  async userLogin() {
    const { dispatch, setSession, auth, showNotification } = this.props;
    const { userPassword } = this.state;
    const userEmail = getURLParameter("email") || undefined;

    this.setState({ modalLoading: true });

    try {
      const userAccess = new UserAccess();
      const hydratedLogin = await userAccess.hydratedLogin(userEmail, userPassword, auth);
      hydratedLogin.user = await userAccess.getUserData();
      dispatch(setSession(hydratedLogin)).then(() => {
        this.setState({ showEmailModal: false, loading: true });
        this.loadData();
      })
    } catch (error) {
      this.setState({ modalLoading: false });

      if (error.message === "Password dont match" || error.message === "User not found") {
        showNotification("invalidLoginData");
        this.refs.userPassword.setInvalid();
      } else {
        showNotification("genericError");
      }
    }
  }

  async refreshTestsData() {
    const { setTestsData, dispatch } = this.props;
    this.setState({ refreshingData: true });

    try {
      const campaignAccess = new CampaignAccess();
      const refreshedTestsData = await campaignAccess.getCampaigns();
      dispatch(setTestsData(refreshedTestsData)).then(()=> this.loadData());

      this.setState({ refreshingData: false });
    } catch (error) {
      this.loggout();
    }
  }

  async loadData() {
    if (this._mount) {
      const { testsData } = this.props;

      const savedDate = new Date(localStorage.getItem('desktop-promo')) || undefined;
      const nowDate = new Date();

      if (!savedDate || nowDate > savedDate) {
        this.setState({ showDesktopPromo: true })
        nowDate.setDate(nowDate.getDate() + 1);
        localStorage.setItem('desktop-promo', nowDate);
      }

      const campaignId = getURLParameter("id") || undefined;

      if (testsData) {
        let campaignData = testsData[testsData.length - 1];

        if (testsData.filter(test => test.campaignId === campaignId).length > 0) {
          campaignData = testsData.filter(test => test.campaignId === campaignId)[0];
          this.setState({ campaignData, loadingCampaign: false });

          const campaignAccess = new CampaignAccess();
          const links = await campaignAccess.getLinks(campaignId);

          if (links.length > 0)
            this.setState({ link: links[0].linkUrl });
        } else if (campaignId) {
          try {
            const campaignAccess = new CampaignAccess();
            const response = await campaignAccess.getLinkByUrl(campaignId);
            campaignData = testsData.filter(test => test.campaignId === response.campaignId)[0];

            this.setState({ link: response.linkUrl });
          } catch (error) {
            showNotification("genericError");
            this.loggout();
          }
        }

        if (campaignData) {
          const { link } = this.state;
          // console.log(campaignData);
          const campaignName = campaignData.data.name;
          const { campaignModules } = campaignData.data.modules;
          const showSendLinkPanel = campaignData.enrolledTesters < 1 && link !== "";

          this.setState({ campaignData, campaignModules, loadingCampaign: false, showSendLinkPanel, campaignName }, () => {
            this.loadAllModules(campaignModules);
          });
        }
      }
    }
  }

  async getFiles(itemModule, stimulis) {
    const fileAccess = new FileAccess();

    if (!stimulis)
      return [];

    const returnStimulis = await Promise.all(stimulis.map(async (stimuli, key) => {
      let fileName = stimuli.id || stimuli.fileName;
      let aspect = null;
      let thumbnail = null;
      let thumbnails = null;
      let metadata = null;

      const file = await fileAccess.getOfflineFile(fileName);

      if (
        itemModule &&
        itemModule.type &&
        (
          itemModule.type === "video" ||
          itemModule.type === "film"
        )
      ) {
        aspect = await getVideoAspect(file.uri);
        thumbnails = await getThumbnails(file.uri, { quality: 0.6, interval: 60 });
        // console.log(thumbnails);
        metadata = await getMetadata(file.uri);
        thumbnail = URL.createObjectURL(thumbnails[parseInt(thumbnails.length / 2)].blob);
      }

      if (
        itemModule &&
        itemModule.type &&
        itemModule.type === "image"
      ) {
        aspect = await getImageAspect(file.uri);
        thumbnail = file.uri;
      }

      return { ...stimuli, file: file.uri, aspect, thumbnail, thumbnails, metadata };
    }));

    return returnStimulis;
  }

  async loadAllModules(campaignModules) {
    const { campaignData } = this.state;
    const campaignModulesClone = JSON.parse(JSON.stringify( campaignModules ));

    const analysisAccess = new AnalysisAccess();
    let allModulesMetrics = [];

    campaignModulesClone.map(item => {
      if (item.type === "qa") {
        item.questions.map((question) => {
          const qaModule = { ...item };
          qaModule.questions = [ question ]

          allModulesMetrics.push(qaModule);
        });
      } else {
        if (item.tech !== 'play') {
          allModulesMetrics.push(item);
        }
      }
    });

    const campaignDataDemo = await analysisAccess.campaignMetrics(campaignData.campaignId, true);
    const metricsDemoModules = campaignDataDemo.modules_metrics;

    allModulesMetrics = await Promise.all(allModulesMetrics.map(async itemModule => {
      // console.log(itemModule);
      const { showDemoData } = this.state;

      if (itemModule.tech === "recognition") {
        let metrics = {};

        if (showDemoData) {
          metrics = metricsDemoModules.filter(demoModule => demoModule.moduleId === itemModule.id)[0];
        } else {
          metrics = await analysisAccess.moduleMetricsFR(campaignData.campaignId, itemModule.id);
        }

        if (itemModule.type === "film") {
          metrics.stimuli = itemModule.videos;
        }

        metrics.stimuli = await this.getFiles(itemModule, metrics.stimuli);

        return { ...itemModule, ...metrics };
      } else {
        let metrics = {};
        let metricsChoose = {};

        if (showDemoData) {
          const demoModuleFiltered = metricsDemoModules.filter(demoModule => demoModule.moduleId === itemModule.id);
          if (demoModuleFiltered[0] && demoModuleFiltered[0].replies) {
            metrics = demoModuleFiltered[0].replies;
          }

          if (demoModuleFiltered[0] && demoModuleFiltered[0].stimuli) {
            metricsChoose = demoModuleFiltered[0];
          }
        } else {
          metrics = await analysisAccess.moduleRepliesSummary(itemModule.id);
          if (itemModule.type !== "qa") {
            metricsChoose = await analysisAccess.moduleMetricsChoose(campaignData.campaignId, itemModule.id);
          }
        }

        if (itemModule.type === "qa") {
          const questions = itemModule.questions[0];
          questions.answers = parseNivoRepliesQA(metrics, questions);
        } else if (itemModule.type === "image") {
          itemModule.images = await this.getFiles(itemModule, itemModule.images);
          itemModule.images = parseNivoReplies(itemModule.images, metricsChoose);
        } else if (itemModule.type === "video") {
          itemModule.videos = await this.getFiles(itemModule, itemModule.videos);
          itemModule.videos = parseNivoReplies(itemModule.videos, metricsChoose);
        } else if (itemModule.type === "audio") {
          itemModule.audios = await this.getFiles(itemModule, itemModule.audios);
          itemModule.audios = parseNivoReplies(itemModule.audios, metricsChoose);
        }

        return itemModule;
      }
    }));

    this.setState({
      allModulesMetrics,
      loading: false
    }, () => {
      if (document.getElementById("videoPreview")) {
        const videoPreview = document.getElementById("videoPreview");
        const isFilm = (campaignData.data && campaignData.data.type === "film") ? true : false;
        const filmData = isFilm ? allModulesMetrics.filter(item => item.type === "film")[0] : undefined;

        videoPreview.ontimeupdate = () => {
          // console.log(filmData);
          const playerPositionPercentage = 100 * videoPreview.currentTime / videoPreview.duration;
          const totalPoints = filmData.metrics.totalMetricsFR.timeline.length;
          const position = totalPoints / 100 * parseInt(playerPositionPercentage);
          // console.log(position);
          const timelinePositionData = filmData.metrics.totalMetricsFR.timeline[position];

          // console.log(timelinePositionData);

          this.setState({
            previewTime: videoPreview.currentTime,
            previewDuration: videoPreview.duration,
            timelinePositionData
          }, () => {
            // if (this.refs.averageEmotions)
            //   this.refs.averageEmotions.loadData();
          });
        }
      }
    });
  }

  async modifyCampaign() {
    const { showNotification, setTestsData, dispatch, testsData } = this.props;
    const { campaignName, campaignData } = this.state;
    const { campaignId, data } = campaignData;

    this.setState({ modalLoading: true });

    const newData = { ...data, name: campaignName };
    const campaignAccess = new CampaignAccess();
    await campaignAccess.updateCampaign(campaignId, newData);

    await this.refreshTestsData();

    this.setState({ modalLoading: false, showEditTestModal: false });
  }

  onInputChange(val) {
    this.setState(val);
  }

  copyToClipboard(text) {
    const { showNotification } = this.props;

    let tempInput = document.createElement("input");
    tempInput.value = text;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);

    showNotification("copyClipboard");
  }

  goWizard() {
    const { setRedirect } = this.props;
    setRedirect({ route: URL_WIZARD });
  }

  goCampaigns() {
    const { setRedirect } = this.props;
    setRedirect({ route: URL_CAMPAIGNS });
  }

  goModules() {
    const { setRedirect } = this.props;
    const campaignId = getURLParameter("id");
    setRedirect({ route: URL_CAMPAIGN_MODULES_ID.replace('[var1]', campaignId) });
  }

  toggleDemoData() {
    const { showDemoData } = this.state;
    this.setState({ loading: true, showDemoData: !showDemoData }, () => {
      this.loadData();
    });
  }

  toggleSendPanel() {
    const { showSendLinkPanel } = this.state;
    this.setState({ showSendLinkPanel: !showSendLinkPanel });
  }

  renderTime(raw_seconds) {
    const minutes = Math.floor(parseInt(raw_seconds) / 60);
    const seconds = parseInt(raw_seconds) - minutes * 60;

    if (minutes < 1)
      return `${seconds}’’`;

    if (seconds < 1)
      return `${minutes}’`;

    return `${minutes}’  ${seconds}’’`;
  }

  onClickRewind() {
    if (document.getElementById("videoPreview")) {
      const videoPreview = document.getElementById("videoPreview");
      videoPreview.currentTime = 0;
    }
  }

  onClickPlay() {
    if (document.getElementById("videoPreview")) {
      const videoPreview = document.getElementById("videoPreview");

      if (videoPreview.paused) {
        videoPreview.play();
      } else {
        videoPreview.pause();
      }
    }
  }

  render() {
    const {
      loadingCampaign,
      loading,
      refreshingData,
      link,
      showSendLinkPanel,
      showTestOptions,
      allModulesMetrics,
      campaignData,
      showEmailModal,
      modalLoading,
      userPassword,
      showEditTestModal,
      showDemoData,
      showDesktopPromo,
      haveDemo,
      previewTime,
      previewDuration,
      timelinePositionMouseX,
      timelinePositionData
    } = this.state;
    const { location, t } = this.props;

    const campaignName = campaignData.data ? campaignData.data.name : "";
    const isFilm = (campaignData.data && campaignData.data.type === "film") ? true : false;
    const filmData = isFilm ? allModulesMetrics.filter(item => item.type === "film")[0] : undefined;
    const url = link ? `${URL_ENVIRONMENT}/${link}` : "";
    let results = []
    let filmTimelineRows = [];
    let filmTimelineFlashes = [];
    let filmTimelineThumbnails = [];
    let filmItem = filmData ? filmData.stimuli[0] : undefined;
    let timePercentage = 100;
    let videoPreview = undefined;

    if (document.getElementById("videoPreview"))
      videoPreview = document.getElementById("videoPreview");

    // console.log(filmData);
    // console.log(filmData);

    const positionBarLeft = 100 * previewTime / previewDuration;

    if (filmData) {
      const raw_seconds = parseInt(filmData.videos[0].duration);
      const minutes = Math.floor(raw_seconds / 60);
      const seconds = raw_seconds - minutes * 60;
      const featuredInterval = minutes > 30 ? 10 : 1;
      timePercentage = (100 * (minutes * 60)) / raw_seconds;

      // console.log(raw_seconds);
      // console.log(minutes);
      // console.log(seconds);

      for (var i = 0; i <= minutes; i++) {
        filmTimelineRows.push(
          <div key={i} className={(i % featuredInterval) == 0 ? 'featured' : ''}>
            {((i % featuredInterval) == 0) && (
              <div className="label">{i}’</div>
            )}
          </div>
        );
      }

      if (filmItem?.thumbnails) {
        filmTimelineThumbnails = filmItem.thumbnails.map((thumbnail, key) => {
          const thumbnailBlob = URL.createObjectURL(thumbnail.blob)

          // console.log(thumbnail);

          return (
            <div key={key} className="thumbnail"><img src={thumbnailBlob} /></div>
          );
        });

        filmTimelineFlashes = filmData.flashes.map((flash, key) => {
          if (flash.label === "max-interest-bin")
            return false;

          // console.log(flash);
          // thumbnail = URL.createObjectURL(thumbnails[parseInt(thumbnails.length / 2)].blob);
          // console.log(filmItem.thumbnails);

          let startAt = 100 * flash.bin[0] / raw_seconds;
          let endsAt = undefined;
          let durationTime = `${this.renderTime(flash.bin[0])}`;
          let outsideLeft = false;
          let outsideRight = false;

          if (flash.bin[1]) {
            endsAt = (100 * flash.bin[1] / raw_seconds) - startAt;
            durationTime = `${durationTime} - ${this.renderTime(flash.bin[1])}`;
          }

          // console.log(startAt);

          if (startAt < 15) {
            outsideLeft = true;
          }

          if (endsAt > 85) {
            outsideRight = true;
          }

          let left = startAt ? `${startAt}%` : "0px";
          let width = endsAt ? `${endsAt}%` : "15px";
          let type = "good";

          if (flash.label === "loss-of-attention") {
            type = "bad"
          } else if (flash.label === "little-activation") {
            type = "poor"
          }

          const thumbnailBlob = URL.createObjectURL(filmItem.thumbnails[key].blob)

          return (
            <div key={key} className={`track ${type} ${outsideLeft ? "outside-left" : ""} ${outsideRight ? "outside-right" : ""}`} style={{ left, width }}>
              <div className="popup">
                <div className="title">{t(`Metrics_Flashes_${flash.label}`)}<br/>{durationTime}</div>
                <div className="thumbnail"><img src={thumbnailBlob} /></div>
              </div>
            </div>
          );
        });
      }
    }

    results = allModulesMetrics.filter(item => item.type !== 'film').map((itemModule, key) => (
      <MetricsModule
        key={key}
        position={key + 1}
        itemModule={itemModule}
      />
    ));

    return (
      <div className="app screen-metrics">
        <Helmet>
          <title>{t('Metrics_Browser_Title')}</title>
        </Helmet>
        {showDesktopPromo && (
          <div className="desktop-promo-modal only-mobile">
            <div className="cover"></div>
            <div className="modal">
              <div className="content">
                <div className="header">
                  <h2><T text="Metrics_Desktop_Promo_Title" /></h2>
                  <div className="button-close" onClick={() => this.setState({ showDesktopPromo: false })}>
                    <i className="icon icon-cancel-7"></i>
                  </div>
                </div>
                <div className="desktop-promo-list">
                  <p className="icon-text">
                    <i className="icon icon-brush-1"></i>
                    <T text="Metrics_Desktop_Promo_List1_Title" />
                  </p>
                  <p><T text="Metrics_Desktop_Promo_List1_Text" /></p>
                  <p className="icon-text">
                    <i className="icon icon-language-1"></i>
                    <T text="Metrics_Desktop_Promo_List2_Title" />
                  </p>
                  <p><T text="Metrics_Desktop_Promo_List2_Text1" /></p>
                  {/*
                  <p className="icon-text">
                    <i className="icon icon-popup"></i>
                    ¿Necesitas un test más completo?
                  </p>
                  <p>Puedes añadir y combinar más módulos a tu test de audio, video o imágen.</p>
                  <p className="icon-text">
                    <i className="icon icon-link-1"></i>
                    Compara tus fuentes de entrada
                  </p>
                  <p>Crea enlaces a tu test para tus diferentes fuentes de entrada. Podrás ver las estádisticas de adquisición de cada una de ellas por género, ciudad y rango de edad.</p> 
                  */}
                </div>
                <div className="desktop-box">
                  <p><T text="Metrics_Desktop_Promo_List2_Text2" /></p>
                </div>
              </div>
            </div>
          </div>
        )}
        <ModalDialog
          name="Lite_User_Login"
          showModal={showEmailModal}
          loading={modalLoading}
          onConfirm={() => { this.userLogin() }}
          fullCTA={true}
        >
          <Input
            readOnly={modalLoading}
            type="password"
            last
            placeholder={t('Lite_User_Email_Input_Password_Placeholder')}
            name="userPassword"
            label={t('Lite_User_Email_Input_Password')}
            value={userPassword}
            ref="userPassword"
            onChange={val => this.onInputChange(val)}
          />
        </ModalDialog>
        <ModalDialog
          name="Lite_Test_Edit"
          showModal={showEditTestModal}
          loading={modalLoading}
          onConfirm={() => { this.modifyCampaign() }}
          onCancel={e => { this.setState({ showEditTestModal: false }) }}
          closeModal={e => { this.setState({ showEditTestModal: false }) }}
        >
          <Input
            readOnly={modalLoading}
            last
            placeholder={t('Lite_Test_Edit_Modal_Input_Name_Placeholder')}
            name="campaignName"
            label={t('Lite_Test_Edit_Modal_Input_Name')}
            value={campaignName}
            ref="campaignName"
            onChange={val => this.onInputChange(val)}
          />
        </ModalDialog>
        <div className="main-wrapper metrics">
          {loadingCampaign && (
            <div className="loading-cover">
              <div className="cover"></div>
              <div>
                <Spinner speed={0.8} color="#ffffff" size={20} />
              </div>
            </div>
          )}
          <TopBar ref="topbar" location={location} />
          <MobileTopBar
            subtitle="Resultados"
            title={campaignName}
            haveDemo={haveDemo}
            showDemoData={showDemoData}
            onClickToggleDemoData={() => this.toggleDemoData()}
            onClickBackButton={() => this.refs.topbar.goTests()}
          >
            <div className="btn-icon btn-send-test" onClick={() => this.refreshTestsData()}>
              <i className={refreshingData ? 'icon icon-spin4 animate-spin' : 'icon icon-spin3'}></i>
            </div>
            <div className="btn-icon btn-send-test" onClick={() => this.refs.topbar.goRecopilator(campaignData)}>
              <i className='icon icon-paper-plane-1'></i>
            </div>
            <div className="btn-icon btn-send-test" onClick={() => this.toggleTestOptions()}>
              <i className='icon icon-dot-3'></i>
              {showTestOptions && (
                <div className="test-options-menu">
                  <div><Link inline onClick={() => this.setState({ showEditTestModal: true, modalLoading: false })}>Editar título</Link></div>
                  <div><Link inline onClick={() => this.setState({ showSendLinkPanel: true, modalLoading: false })}>Enviar test</Link></div>
                  {/* <div className="separator"></div>
                  <div><Link inline onClick={() => { this.loggout() }}><T text="TopBar_Submenu_Close_Session" /></Link></div> */}
                </div>
              )}
            </div>
          </MobileTopBar>
          <ContentHeader
            location={location}
            campaignData={campaignData}
            haveDemo={haveDemo}
            showDemoData={showDemoData}
            onClickToggleDemoData={() => this.toggleDemoData()}
          />
          <div className={showDemoData ? "fluid screen-content show-demo-data" : "fluid screen-content"}>
            <div className={`fluid-wrapper content-wrapper ${!isFilm ? "small" : ""}`}>
              {loading && (
                <div className="loading-cover">
                  <div>
                    <Spinner speed={0.8} color="#00C7E7" size={20} />
                  </div>
                </div>
              )}
              {!loading && results.length > 0 && (
                <>
                  {isFilm && filmData && (
                    <>
                      {/* <div className="film-name">{filmData.filmName}</div> */}

                      <div className="content-wrapper recopilator">
                        <h2><span>Destellos</span></h2>
                        <div className="blink-timeline">
                          <div className="timeline">
                            <div className="times" style={{ width: `${timePercentage}%` }}>
                              {filmTimelineRows}
                            </div>
                            {filmTimelineFlashes}
                          </div>
                        </div>
                      </div>

                      <div className="content-wrapper recopilator">
                        <h2><span>Audiencia</span></h2>
                        <div className="content-widget summary compact">
                          <div className="summary">
                            <div className="col featured">
                              <div className="title">Tests realizado</div>
                              <div className="value">{filmData.audience.realizedTests || "-"}</div>
                            </div>
                            <div className="col">
                              <div className="title">Edades más interesadas</div>
                              <div className="value green">{filmData.audience.mostInterestedAges}</div>
                            </div>
                            <div className="col">
                              <div className="title">Género más interesado</div>
                              <div className="value green">{filmData.audience.mostInterestedGender}</div>
                            </div>
                            <div className="col">
                              <div className="title">Localidad más interesada</div>
                              <div className="value green">{filmData.audience.mostInterestedLocation}</div>
                            </div>
                            <div className="col">
                              <div className="title">Edades menos interesadas</div>
                              <div className="value red">{filmData.audience.lessInterestedAges}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="content-wrapper recopilator">
                        <h2><span>Emociones</span></h2>
                        <div className="content-widget summary compact">
                          <div className="summary">
                            <div className="col">
                              <div className="title">Emoción > 55%</div>
                              <div className="value green">{this.renderTime(filmData.emotions.emotionOverPercentage)}</div>
                            </div>
                            <div className="col">
                              <div className="title">Pérdida de Atención</div>
                              <div className="value green">{this.renderTime(filmData.emotions.lossOfAttention)}</div>
                            </div>
                            <div className="col">
                              <div className="title">Precisión de los Datos</div>
                              <div className="value green">{filmData.emotions.dataAccuracy}</div>
                            </div>
                            <div className="col">
                              <div className="title">Emoción Predominante</div>
                              <div className="value red">{filmData.emotions.predominantEmotion}</div>
                            </div>
                            <div className="col">
                              <div className="title">Emoción Secundaria</div>
                              <div className="value green">{filmData.emotions.secondaryEmotion}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="content-wrapper recopilator film-metrics">
                        <h2><span>Métricas</span></h2>
                        <div className="controls">
                          <span className="rewind" onClick={() => this.onClickRewind()}>
                            <i className="icon-to-start-3"></i>
                          </span>
                          <span className="play" onClick={() => this.onClickPlay()}>
                            {(videoPreview && videoPreview.paused) && (
                              <i className="icon-play-4"></i>
                            )}
                            {(videoPreview && !videoPreview.paused) && (
                              <i className="icon-pause-4"></i>
                            )}
                          </span>
                        </div>
                        <div className="player">
                          {(filmItem?.file && videoPreview && videoPreview.paused) && (
                            <div className="play-message">Press "space bar" to play film</div>
                          )}
                          {filmItem?.file && (
                            <video id="videoPreview" onClick={e => this.onClickPlay()} controls={false} preload="true" src={filmItem.file} />
                          )}
                        </div>
                        <div
                          id="video-timeline"
                          className="video-timeline"
                          onMouseMove={e => {
                            const rect = document.getElementById("video-timeline").getBoundingClientRect();
                            const x = e.clientX - rect.left;
                            const timelinePositionMouseX = 100 * x / rect.width;

                            // const totalPoints = filmData.metrics.totalMetricsFR.timeline.length;
                            // const position = totalPoints / 100 * parseInt(timelinePositionMouseX);
                            // const timelinePositionData = filmData.metrics.totalMetricsFR.timeline[position];
                            this.setState({ timelinePositionMouseX });
                          }}
                          onClick={e => {
                            const rect = document.getElementById("video-timeline").getBoundingClientRect();
                            const x = e.clientX - rect.left;
                            const timelinePositionMouseX = 100 * x / rect.width;

                            const totalPoints = filmData.metrics.totalMetricsFR.timeline.length;
                            const position = totalPoints / 100 * parseInt(timelinePositionMouseX);
                            const timelinePositionData = filmData.metrics.totalMetricsFR.timeline[position];
                            if (document.getElementById("videoPreview")) {
                              const videoPreview = document.getElementById("videoPreview");
                              videoPreview.currentTime = timelinePositionData.second;
                            }
                            this.setState({ timelinePositionMouseX });
                          }}
                        >
                          <div className="blink-timeline">
                            <div className="timeline">
                              <div className="times" style={{ width: `${timePercentage}%` }}>
                                {filmTimelineRows}
                              </div>
                              {filmTimelineFlashes}
                            </div>
                          </div>
                          <EmotionalOverviewFilm
                            ref="emotionalOverview"
                            activeModule={filmData}
                            activeModuleTimeline={filmData.metrics.totalMetricsFR.timeline}
                            activeModuleFileName={filmItem.fileName}
                            metricDuration={filmItem.duration}
                          />
                          <EmotionalOverviewFilm
                            ref="emotionalOverview"
                            activeModule={filmData}
                            activeModuleTimeline={filmData.metrics.totalMetricsFR.timeline}
                            activeModuleFileName={filmItem.fileName}
                            metricDuration={filmItem.duration}
                            attention
                          />
                          <div className="position-bar" style={{ left: `${positionBarLeft}%` }}>
                          <div className="time">
                              {this.renderTime(previewTime)}
                            </div>
                          </div>
                          <div className="position-bar mouse" style={{ left: `${timelinePositionMouseX}%` }}>
                            {timelinePositionData?.second && (
                              <div className="time">
                                {this.renderTime(timelinePositionData.second)}
                              </div>
                            )}
                          </div>
                          {timelinePositionData && timelinePositionData.emotions && (
                          <div className="tooltip-info">
                            Attention: {timelinePositionData.attention}%<br/>
                            Activation: {timelinePositionData.activation}%<br/><br/>
                            Happiness: {timelinePositionData.emotions.happiness}%<br/>
                            Surprise: {timelinePositionData.emotions.surprise}%<br/>
                            Sadness: {timelinePositionData.emotions.sadness}%<br/>
                            Fear: {timelinePositionData.emotions.fear}%<br/>
                            Anger: {timelinePositionData.emotions.anger}%<br/>
                            Disgust: {timelinePositionData.emotions.disgust}%<br/>
                            {/* <AverageEmotionsFilms
                              ref="averageEmotions"
                              activeModuleData={timelinePositionData.emotions}
                            /> */}
                          </div>
                          )}
                        </div>
                      </div>

                      {result.length > 0 && (
                        <div className="content-wrapper recopilator only-title">
                          <h2><span>Encuesta</span></h2>
                        </div>
                      )}
                    </>
                  )} {/* END FILM TYPE METRICS */}
                  {results}
                </>
              )}
              {!loading && results.length < 1 && (
                 <div className="no-results-msg">
                  <img src="../assets/img/no-campaigns-img.png" alt="No campaigns" />
                  <h2><T text="Metrics_Test_Without_Modules_Title" /></h2>
                  <p><T text="Metrics_Test_Without_Modules_Text" /></p>
                  <Link main onClick={() => this.goModules()}>
                    <T text="Metrics_Test_Without_Modules_Link" />
                  </Link>
                </div>
              )}
            </div>
            <div className="show-demo-data-bottom only-desktop"></div>
          </div>
          <div className={`fixed-bottom small only-mobile metrics-send-link ${showSendLinkPanel ? 'open' : ''}`}>
            <div className="header" onClick={() => this.toggleSendPanel()}>
              <h3><T text="Metrics_Share_Link_Title" /></h3>
              <div className="close-button">
                <i className={`icon ${showSendLinkPanel ? 'icon-down-open-1' : 'icon-up-open-1'}`}></i>
              </div>
            </div>
            <div className="file">
              <i className="icon icon-link-1"></i>
              <div className="url-wrapper">{url}</div>
              <Link main onClick={() => this.copyToClipboard(url)}>
                <T text="Metrics_Share_Link_Button_Copy" />
              </Link>
            </div>
            <p><T text="Metrics_Share_Link_Text" /></p>
            <h2><T text="Metrics_Share_Link_Buy_Audience_Title" /></h2>
            <Link main className="featured full-width" onClick={() => this.refs.topbar.goBuyAudience(campaignData)}>
              <T text="Metrics_Share_Link_Buy_Audience_Button" />
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(Metrics);
